module.exports = __webpack_public_path__ + "static/media/Home-YellowCircle1.caed9117.svg";